import { inject, Injectable } from '@angular/core';
import { SimpleCommand } from '@app-shared/command/async-simple-command.interface';
import { OnboardingService } from '@app-shared/services/onboarding/onboarding.service';
import { FlowNavigatorService } from '../services/flow-navigator.service';

@Injectable()
export class OnboardingPreviousScreenCommand implements SimpleCommand {
  private _flowNavigatorService = inject(FlowNavigatorService);
  private _onboardingService = inject(OnboardingService);

  async execute(): Promise<void> {
    await this._onboardingService.save();
    await this._flowNavigatorService.navigatePrevious();
  }

  async executeJump(jumpToPath: number): Promise<void> {
    await this._onboardingService.save();
    await this._flowNavigatorService.jumpPrevious(jumpToPath);
  }

  async executeJumpToPath(path: string): Promise<void> {
    await this._onboardingService.save();
    await this._flowNavigatorService.jumpToPath(path);
  }
}
